import { useOperador } from "./useOperador";

export const usePermissao = () => {
    const { permissoes } = useOperador();

    // verifica se o operador possui um tipo de permissao (ex: tipo 10)
    const possuiTipo = (tipo) => {
        return permissoes?.some((perm) => perm.tipo === tipo);
    };

    // verifica se o operador possui um IDPermissao específico
    const possuiIDPermissao = (IDPermissao) => {
        return permissoes?.some((perm) => perm.IDPermissao === IDPermissao);
    };

    return {
        possuiTipo,
        possuiIDPermissao,
        permissoes,
    };
};
